import { Workbox } from "workbox-window";

const SW_RELOAD_GUARD_KEY = "sw_reload_performed";

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    const wb = new Workbox(swUrl);
    let refreshing = false;

    const reloadOnceIfUpdate = (event) => {
      const alreadyReloaded = sessionStorage.getItem(SW_RELOAD_GUARD_KEY) === "1";
      if (event.isUpdate && !refreshing && !alreadyReloaded) {
        sessionStorage.setItem(SW_RELOAD_GUARD_KEY, "1");
        refreshing = true;
        window.location.reload();
      }
    };

    wb.addEventListener("waiting", () => {
      wb.messageSkipWaiting();
    });

    wb.addEventListener("controlling", reloadOnceIfUpdate);

    const checkForUpdate = () => {
      wb.update().catch(() => {});
    };

    wb.register()
      .then(() => {
        checkForUpdate();
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            checkForUpdate();
          }
        });
        window.addEventListener("focus", checkForUpdate);
      })
      .catch((err) => {
        console.error("[service-worker]", err);
      });
  });
}
